var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarIconColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0423 13.4577H16.6257C17.1007 13.4577 17.4173 13.141 17.4173 12.666V10.291C17.4173 9.57852 16.8632 8.94518 16.2298 8.78685C14.8048 8.39102 12.6673 7.91602 12.6673 7.91602C12.6673 7.91602 11.6382 6.80768 10.9257 6.09518C10.5298 5.77852 10.0548 5.54102 9.50065 5.54102H3.95898C3.48398 5.54102 3.08815 5.85768 2.85065 6.25352L1.74232 8.54935C1.63749 8.85511 1.58398 9.17612 1.58398 9.49935V12.666C1.58398 13.141 1.90065 13.4577 2.37565 13.4577H3.95898",
    stroke: "#2563EB",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54232 15.0417C6.41677 15.0417 7.12565 14.3328 7.12565 13.4583C7.12565 12.5839 6.41677 11.875 5.54232 11.875C4.66787 11.875 3.95898 12.5839 3.95898 13.4583C3.95898 14.3328 4.66787 15.0417 5.54232 15.0417Z",
    stroke: "#2563EB",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 13.459H11.875",
    stroke: "#2563EB",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 15.0417C14.3328 15.0417 15.0417 14.3328 15.0417 13.4583C15.0417 12.5839 14.3328 11.875 13.4583 11.875C12.5839 11.875 11.875 12.5839 11.875 13.4583C11.875 14.3328 12.5839 15.0417 13.4583 15.0417Z",
    stroke: "#2563EB",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIconColored);
export default __webpack_public_path__ + "static/media/carIconColored.9f8c97d0f6bfd078f9be945f43cff74d.svg";
export { ForwardRef as ReactComponent };